<head>
  <link rel="stylesheet" href="https://use.typekit.net/ahw0mno.css"></link>
  <link rel="stylesheet" href="https://use.typekit.net/ahw0mno.css"></link>
  <link href='https://api.mapbox.com/mapbox-gl-js/v1.10.1/mapbox-gl.css' rel='stylesheet' />
  <link href='https://api.tiles.mapbox.com/mapbox-gl-js/v2.9.2/mapbox-gl.css' rel='stylesheet' />
  <link rel="stylesheet" href="https://use.typekit.net/ahw0mno.css"></link>
</head>

<template>
  <div id="Map" ref="map">


    <audio preload="metadata" :src="require('../assets/audio/BridgerBayBeach.mp3')" ref="audio1" @timeupdate="UpdateTime(1)" ></audio>
    <audio preload="metadata" :src="require('../assets/audio/BuffaloPoint.mp3')" ref="audio2" @timeupdate="UpdateTime(2)" ></audio>
    <audio preload="metadata" :src="require('../assets/audio/Causeway1.mp3')" ref="audio3" @timeupdate="UpdateTime(3)" ></audio>
    <audio preload="metadata" :src="require('../assets/audio/Causeway2.mp3')" ref="audio4" @timeupdate="UpdateTime(4)" ></audio>
    <audio preload="metadata" :src="require('../assets/audio/FGR.mp3')" ref="audio5" @timeupdate="UpdateTime(5)" ></audio>

    <div style="width: 100%; height: 74vh">
      <v-card v-if="notInAreaErrorMessage == true" class="errorMessage">
            <v-card-title class="errorTitle" style="word-break: break-word">
                Your location is not close enough to Antelope Island.
            </v-card-title>
            <v-card-text style="font-family: 'Lato'"> You are not close enough to an Antelope Island Audio Location. You can wait till you get close enough, or you can click through a list of the audio files.</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    class="actionText2"
                    text
                    @click="notInAreaErrorMessage = false"
                >
                    Wait
                </v-btn>
                <v-btn
                    class="actionText"
                    text
                    @click="goToList()"
                >
                    Go To List
                </v-btn>
            </v-card-actions>
      </v-card>

      <v-card v-if="navError == true" class="errorMessage">
            <v-card-title class="errorTitle" style="word-break: break-word">
                There is a problem with trying to get your location.
            </v-card-title>
            <v-card-text style="font-family: 'Lato'">check to see why the navigator geolocation isn't working</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    class="actionText2"
                    text
                    @click="navError = false"
                >
                    Close
                </v-btn>
            </v-card-actions>
      </v-card>


      <v-card v-if="watchError == true" class="errorMessage">
            <v-card-title class="errorTitle" style="word-break: break-word">
                There is a problem
            </v-card-title>
            <v-card-text style="font-family: 'Lato'">check and see why the watch location is not working</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    class="actionText2"
                    text
                    @click="watchError = false"
                >
                    Close
                </v-btn>
            </v-card-actions>
      </v-card>

      <MapBox />
    </div>
    
    <v-bottom-navigation
      class="bottomStick"
      style="height: 26vh; width: 100%;"
    >


    <!-- normal audio stuff -->
      <v-flex style="display:flex; flex-direction:column; width: 100%" v-if="info == false">
        <v-flex class="control-flex">
          <v-icon
            @click="infoSheet()">mdi-information-variant</v-icon>
          <v-icon>mdi-skip-previous</v-icon>
          <v-icon v-show="audioState =='pause'" v-on:click="pickAudio(chosenAudio)">mdi-play</v-icon>
          <v-icon v-show="audioState =='play'" v-on:click="pickAudio(chosenAudio)">mdi-pause</v-icon>
          <v-icon>mdi-skip-next</v-icon>
          <v-icon
            @click="sideSheet()">mdi-view-list</v-icon>
        </v-flex>
        <div style="display:flex; justify-content: center">
          <h3 id="audioTitle">{{ audioName }}</h3>
        </div>
        <div style="display: flex; align-items: center; justify-content: center; margin: 0px 20px">
          <v-icon @click="back10()" class="otherButtons">mdi-rewind-10</v-icon>
          <!-- <audio>
            <source src={{ audioItem }}>
          </audio> -->

          <!-- <div class="currentProgressBar">
            <div class="currentProgress"></div>
          </div> -->

        
          <v-slider
            v-model="currentTime"
            :color="slider.color"
            min="0"
            :max="totalAudioTime"
            

          ></v-slider>
            

          <v-icon @click="forward10()" class="otherButtons">mdi-fast-forward-10</v-icon>
        </div>

        <div style="display: flex; justify-content: space-between; margin: 0px 52px 20px 52px;">
          <p>{{fancyCurrentTime}}</p>
          <p>{{fancyTotalAudioTime}}</p>
        </div>
      </v-flex>

      <v-flex v-if="info == true">
        <v-icon
          @click="closeInfo()"
          id="close">mdi-close
        </v-icon>
        <p id="infoText">This app uses your location to determine what audio to play for you. If you aren't hearing any audio when opening the app it is because you are not close enough to any of the pins on the map. If this is the case and you still want to listen to the audios, go to the list view.</p>

      </v-flex>
    </v-bottom-navigation>
  </div>
  
  



  

</template>
<!-- <script async defer 
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBMUwUblOd-XDtR1-55FDlNDD-5dgZhenw&callback=initMap">
</script> -->

<script>
import MapBox from "../components/mapbox.vue"
import NoSleep from "nosleep.js";
//import google from require("https://maps.googleapis.com/maps/api/js?key=AIzaSyBMUwUblOd-XDtR1-55FDlNDD-5dgZhenw&callback=initMap")
  export default {
    components: {
      MapBox,
    },
    data () {
      return {
        audioName: "welcome to antelope island",
        audioState: "pause",
        currentTime: 0,
        fancyCurrentTime: "",
        totalAudioTime: 0,
        fancyTotalAudioTime: "",
        audios: [ "../assets/audio/BuffaloPoint.mp3", "../assets/audio/BridgerBayBeach.mp3","../assets/audio/Causeway1.mp3", "../assets/audio/Causeway2.mp3", "../assets/audio/FGR.mp3"],
        slider: { value: 10, color: 'red'},
        sheet: false,
        audio: null,
        location: null,
        gettingLocation: false,
        errorStr: null,
        chosenAudio: null,
        hiddenElement: 0,
        keepGoingAudio: "keep going!!",
        durations:["0:54", "0:29", "1:04", "0:41", "0:46"],
        notInAreaErrorMessage: false,
        info: false,
        navError: false,
        watchError: false,
        bounds: {
          "Bridger Bay Beach":{
            "keyvalue": 1,
            //new ne 41.054310, -112.254786
            //new sw 41.043894, -112.241209
            "bbox": {north: 41.054310, south: 41.043894, east: -112.254786, west: -112.241209},
            "size": 0.700
          },
          "Buffalo Point":{
            "keyvalue": 2,
            "bbox": {north: 41.035795, south: 41.033278, east: -112.246117, west: -112.256521},
            "size": 0.650
          },
          "Causeway 1":{
            "keyvalue": 3,
            "bbox": {north: 41.097084, south: 41.084288, east: -112.107385, west: -112.163206},
            "size": 1.500
          },
          "Causeway 2":{
            "keyvalue": 4,
            "bbox": {north: 41.087934, south: 41.060522, east: -112.182366, west: -112.243543},
            "size": 1.500
          },
          "FGR":{
            "keyvalue": 5,
            "bbox": {north: 40.932368, south: 40.926975, east: -112.165609, west: -112.172866},
            "size": 0.400
          }
        }
        // apikey: "AIzaSyBMUwUblOd-XDtR1-55FDlNDD-5dgZhenw",
        // mapBoxToken: "sk.eyJ1IjoiamFzb25waXR0cyIsImEiOiJjbDk3ZnhzdXQya3JwM29sZmNiMm92aTd1In0.d9lgpLL28Ux0nNgS-zAByg"      
      }
    },
    created(){
      // this.UpdateTime();
      // this.audio = new Audio('../assets/audio/FGR.mp3')
      //find center points for each audio
      this.findCenters();

      if(!("geolocation" in navigator)){
        this.errorStr = 'Geolocation is not available.';
        this.navError = true;
        return;
      }
      this.gettingLocation = true;
      //get position
      navigator.geolocation.getCurrentPosition(pos => {
        this.gettingLocation = false;
        this.location = pos;
        console.log("created location: ", this.location);
        //console.log("location2: ", this.location.coords.latitude);
        if(this.location.coords.latitude >= 40.842270 & this.location.coords.latitude <= 41.116208 & this.location.coords.longitude >= -112.273911 & this.location.coords.longitude <= -112.117550){
          //this.notInAreaErrorMessage = true;
        }
      }, err => {
        this.gettingLocation = false;
        this.errorStr = err.message;
      })


      

      navigator.geolocation.watchPosition(this.updateLocation, this.errorLocation);
      
      window.addEventListener("load", this.onWindowLoad);

      this.keepScreenAwake();
      
      
    },
    methods: {
      keepScreenAwake() {
        // write me code that will keep the screen awake
        var noSleep = new NoSleep();
        noSleep.enable();
        console.log("noSleep: ", noSleep);
        // let isEnableNoSleep = false;
        // const noSleep = new NoSleep();
        


        
      },
      
      findCenters(){
        console.log("finding centers");
        for (var key in this.bounds) {
          if (this.bounds.hasOwnProperty(key)) {
            var val = this.bounds[key];
            console.log("key: ", key);
            console.log("val: ", val);
            var center = {
              lat: (val.bbox.north + val.bbox.south) / 2,
              lng: (val.bbox.east + val.bbox.west) / 2
            }
            //41.049181, -112.248445
            if(this.bounds[key] == "Bridger Bay Beach"){
              center = {
                lat: 41.049181,
                lng: -112.248445
              }
            }
            console.log("center: ", center);
            this.bounds[key].center = center;
          }
        }
      },
      goToList(){
        this.notInAreaErrorMessage = false;
        this.$router.push("/list");
      },
      sideSheet(){
        this.$refs.audio1.pause();
        this.$refs.audio2.pause();
        this.$refs.audio3.pause();
        this.$refs.audio4.pause();
        this.$refs.audio5.pause();
        
        this.$router.push("/list");
      },
      infoSheet(){
        this.$refs.audio1.pause();
        this.$refs.audio2.pause();
        this.$refs.audio3.pause();
        this.$refs.audio4.pause();
        this.$refs.audio5.pause();

        this.info = true;
      },
      closeInfo(){
        this.info = false;
      },
      // initMap(){
      //   //location on Uluru
      //   console.log("im creating the map");
      //   const uluru = { lat: -25.344, lng: 131.031 };
      //   const map = new google.maps.Map( this.$refs.map , {
      //     zoom: 4,
      //     center: uluru,
      //   });
      //   const marker = new google.maps.Marker({
      //     position: uluru,
      //     map: map,
      //   });
      // },
      onWindowLoad(){
        this.$router.push("/");
      },
      updateLocation(pos){
        this.location = pos;
        console.log('new location is: ', this. location);
        this.checkAudiolocation();
      },
      checkAudiolocation(){
        var withinBounds = false;
        for(var key in this.bounds){
          if(this.bounds.hasOwnProperty(key)){
            var val = this.bounds[key];
            //bounding box area
            // if((this.location.coords.latitude >= val.bbox.south & this.location.coords.latitude <= val.bbox.north) & (this.location.coords.longitude >= val.bbox.west & this.location.coords.longitude <= val.bbox.east)){
            //   this.audioName = key;
            //   this.chooseAudio(val.keyvalue);
            //   withinBounds = true;
            // }
            //circle area
            if(this.distance(this.location.coords.latitude, this.location.coords.longitude, val.center.lat, val.center.lng) <= val.size){
              console.log("you are near: ", key);
              this.audioName = key;
              this.chooseAudio(val.keyvalue);
              withinBounds = true;
            }
          }
        }
        if(!withinBounds){
          console.log("you are not near any geolocation audio triggers");
          // send a message to the user
          if(this.chosenAudio){
            this.chooseAudio(this.chosenAudio);
          }
          else{
            console.log("HERE it should display the error message dialoge!!!!!!!!!!!")
            this.audioName = "Welcome To Antelope Island";
            // this.notInAreaErrorMessage = true;
          }
        }
      },
      errorLocation(){
        console.log("error location function");
        this.watchError = true;
      },
      chooseAudio(x){
        //console.log("chooseAudio function: ", this.chosenAudio);
        console.log("this is x: ", x);
        if (this.chosenAudio != x){
          this.chosenAudio = x;
          console.log("inside if: ", this.chosenAudio);
          this.playAudio(this.chosenAudio);
        }
        else{
          console.log("keep playing current audio, until you enter the next audio boundry.");
        }
      },
      validAudio(x){
        switch(x){
          case 1:
            return this.$refs.audio1;
            break;
          case 2:
            return this.$refs.audio2;
            break;
          case 3:
            return this.$refs.audio3;
            break;
          case 4:
            return this.$refs.audio4;
            break;
          case 5:
            return this.$refs.audio5;
            break;
          default:
            return false;
        }
      },
      pickAudio(x){
        var audio = this.validAudio(x);
        if(audio){
          console.log("valid audio");
        }else{
          console.log("invalid audio");
          x = 3;
          audio = this.validAudio(x);
        }
        //play or pause audio and set the state and chosen audio
        this.chosenAudio = x;
        if(this.audioState == 'pause'){
          audio.play();
          this.audioState = "play";
        }
        else{
          audio.pause();
          this.audioState = "pause";
        }
      },
      playAudio(x){
        console.log("inside the playAudio function before the duration")
        var audio = this.validAudio(x);
        if(audio){
          console.log("valid audio");
        }else{
          console.log("invalid audio");
          x = 3;
          audio = this.validAudio(x);
        }
        this.$refs.audio1.pause();
        this.$refs.audio2.pause();
        this.$refs.audio3.pause();
        this.$refs.audio4.pause();
        this.$refs.audio5.pause();
        this.totalAudioTime = audio.duration;
        this.fancyTotalAudioTime = this.durations[x-1];
        audio.play();
        this.audioState = "play";
      },
      //  ****************************************************************************** 
      //  functions that calculate miles from two GPS coordinates 
      //  distance(lat1,lon1,lat2,lon2) will return the distance in miles from (lat1,lon1) to (lat2,lon2)
      /* Distance between two lat/lng coordinates in km using the Haversine formula */
      distance(lat1, lng1, lat2, lng2, miles) { // miles optional
        if (typeof miles === "undefined"){miles=false;}
        function deg2rad(deg){return deg * (Math.PI/180);}
        function square(x){return Math.pow(x, 2);}
        var r=6371; // radius of the earth in km
        lat1=deg2rad(lat1);
        lat2=deg2rad(lat2);
        var lat_dif=lat2-lat1;
        var lng_dif=deg2rad(lng2-lng1);
        var a=square(Math.sin(lat_dif/2))+Math.cos(lat1)*Math.cos(lat2)*square(Math.sin(lng_dif/2));
        var d=2*r*Math.asin(Math.sqrt(a));
        if (miles){return d * 0.621371;} //return miles
        else{return d;} //return km
      },
      fancyTimeFormat: function(s) {
        // console.log("before, ", s);
        // console.log((s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s);
        // console.log(s-(s %= 60));
			  return String((s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s);
		  },
      UpdateTime(x){
        if(x == 1){
          this.currentTime = this.$refs.audio1.currentTime;
          //this.totalAudioTime = this.$refs.audio1.duration;
        }
        else if(x == 2){
          this.currentTime = this.$refs.audio2.currentTime;
          //this.totalAudioTime = this.$refs.audio2.duration;
        }
        else if(x == 3){
          this.currentTime = this.$refs.audio3.currentTime;
          //this.totalAudioTime = this.$refs.audio3.duration;
        }
        else if(x == 4){
          this.currentTime = this.$refs.audio4.currentTime;
          //this.totalAudioTime = this.$refs.audio4.duration;
        }
        else if(x == 5){
          this.currentTime = this.$refs.audio5.currentTime;
          //this.totalAudioTime = this.$refs.audio5.duration;
        }
        else{
          console.log("error with audio time");
        }

        // console.log("duration: ", this.totalAudioTime);

        this.currentTime = Math.round(this.currentTime);
        //console.log("current time: ", this.currentTime);
        // this.totalAudioTime = Math.round(this.totalAudioTime);
        // console.log("duration rounded: ", this.totalAudioTime);

        this.fancyCurrentTime = this.fancyTimeFormat(this.currentTime);
        // this.fancyTotalAudioTime = this.fancyTimeFormat(this.totalAudioTime);
        // console.log("fancy duration: ", this.fancyTotalAudioTime);

      },
      forward10(){
            if(this.chosenAudio == 1){
              this.$refs.audio1.currentTime += 10;
              this.currentTime += 10;
            }
            else if(this.chosenAudio == 2){
              this.$refs.audio2.currentTime += 10;
              this.currentTime += 10;
            }
            else if(this.chosenAudio == 3){
              this.$refs.audio3.currentTime += 10;
              this.currentTime += 10;
            }
            else if(this.chosenAudio == 4){
              this.$refs.audio4.currentTime += 10;
              this.currentTime += 10;
            }
            else if(this.chosenAudio == 5){
              this.$refs.audio5.currentTime += 10;
              this.currentTime += 10;
            }
            else{
              console.log("error with forward10");
            }
          },
          back10(){
            if(this.chosenAudio == 1){
              this.$refs.audio1.currentTime -= 10;
              this.currentTime -= 10;
            }
            else if(this.chosenAudio == 2){
              this.$refs.audio2.currentTime -= 10;
              this.currentTime -= 10;
            }
            else if(this.chosenAudio == 3){
              this.$refs.audio3.currentTime -= 10;
              this.currentTime -= 10;
            }
            else if(this.chosenAudio == 4){
              this.$refs.audio4.currentTime -= 10;
              this.currentTime -= 10;
            }
            else if(this.chosenAudio == 5){
              this.$refs.audio5.currentTime -= 10;
              this.currentTime -= 10;
            }
            else{
              console.log("error with back10");
            }
          },
      showList(){
        if(this.sheet == true){
          this.sheet = false;
          console.log(this.sheet);
        } else{
          this.sheet = true;
          console.log(this.sheet);
        }
      }
      // audioClicked(){
      //   if(audioPlay.paused){
      //     audioPlay.play();
      //     audioState = "play";
      //   }
      //   else{
      //     audioPlay.pause();
      //     audioState = "pause";
      //   }
      // }
    },
    mounted(){
      //this.initMap()
    },
    computed: {
      
    }
  }
</script>

<style>
  #Map{
    /* background-image: url(../assets/images/placermap.svg); */
    background-size: cover;
    height: 100vh;
  }
  .bottomStick{
    position: fixed;
    bottom: 0;
    height: 150px;
  }
  .theme--light.v-btn.v-btn--has-bg{
    background-color: white;
  }
  .control-flex{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin: 15px 30px;
  }
  .flex{
    flex: unset;
  }
  h3{
    font-size: 14px;
    line-height: 21px;
  }
  .currentProgressBar{
    width: 75%;
    background-color: #414141;
    margin: 0.75rem;
    height: 1px;
  }
  .red{
    background-color: #5E727F !important;
  }
  .control-flex > i {
    border-width: 1px;
    border-style: solid;
    border-color: #C8C8C8;
    border-radius: 90px;
    padding: 10px;
  }
  .control-flex > button {
    border-width: 1px;
    border-style: solid;
    border-color: #C8C8C8;
    border-radius: 90px;
    padding: 10px;
    width: unset;
  }
  p{
    font-size: 14px;
    text-align: center;
  }
  .v-messages{
    display: none;
  }
  .text-center{
    background-color: aquamarine;
    width: 100%;
    height: 90vh;
  }
  #audioTitle{
    color: #414141;
    font-family: pulpo, serif;
  }
  .otherButtons{
    width: unset;
  }
  .GPSoverlay{
    z-index: 1;
    background-color: black;
  }
  .GPSoverlay > p{
    color: white;
  }


  .mapboxgl-ctrl-bottom-left{
    display: none;
  }
  .mapboxgl-ctrl-bottom-right{
      display: none;
  }
  .mapboxgl-ctrl-logo {
      display: none !important;
  }


  .errorMessage{
    z-index: 1;
  }
  .actionText{
    color: #D79A02 !important;
    width: unset;
  }
  .actionText2{
    width: unset;
  }
  .errorTitle{
    font-family: 'Lato';
    font-style: bold;
  }
  #close{
    width: unset;
    position: absolute;
    right: 12px;
    top: 10px;
  }
  #infoText{
    margin-top: 35px;
    text-align: left;
    padding: 0px 12px;
    font-family: 'Lato';
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
  }
  #hiddenElement{
    display: none;
  }
</style>